<script setup>
import { useI18n } from 'vue-i18n';

import ActivityCard from 'dashboard/components-next/Activities/ActivityCard.vue';

defineProps({
  activities: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['complete', 'edit', 'delete']);

const { t } = useI18n();

const handleComplete = activityId => {
  emit('complete', activityId);
};

const handleEdit = activity => {
  emit('edit', activity);
};

const handleDelete = activity => {
  emit('delete', activity);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      v-if="activities.length === 0"
      class="flex flex-col items-center justify-center py-12 text-slate-500"
    >
      <span class="i-lucide-inbox size-8 mb-2 text-slate-400" />
      <p class="text-sm text-slate-500">
        {{ t('ACTIVITIES.LIST.EMPTY') }}
      </p>
    </div>
    <ActivityCard
      v-for="activity in activities"
      :key="activity.id"
      :activity="activity"
      @complete="handleComplete"
      @edit="handleEdit"
      @delete="handleDelete"
    />
  </div>
</template>
